module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori2-a682393ad189e75dc5709b1eaf3c0159.jpg";